module.exports = __webpack_public_path__ + "img/sharp_bg2.1a9867a1.png";